import React from 'react';

export default () => (
  <svg
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.90901 1.62416C3.33097 1.2022 3.90326 0.965149 4.5 0.965149H10.5C10.6989 0.965149 10.8897 1.04417 11.0303 1.18482L15.5303 5.68482C15.671 5.82547 15.75 6.01624 15.75 6.21515V15.2151C15.75 15.8119 15.5129 16.3842 15.091 16.8061C14.669 17.2281 14.0967 17.4651 13.5 17.4651H4.5C3.90326 17.4651 3.33097 17.2281 2.90901 16.8061C2.48705 16.3842 2.25 15.8119 2.25 15.2151V3.21515C2.25 2.61841 2.48705 2.04612 2.90901 1.62416ZM4.5 2.46515C4.30109 2.46515 4.11032 2.54417 3.96967 2.68482C3.82902 2.82547 3.75 3.01624 3.75 3.21515V15.2151C3.75 15.4141 3.82902 15.6048 3.96967 15.7455C4.11032 15.8861 4.30109 15.9651 4.5 15.9651H13.5C13.6989 15.9651 13.8897 15.8861 14.0303 15.7455C14.171 15.6048 14.25 15.4141 14.25 15.2151V6.52581L10.1893 2.46515H4.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 0.965149C10.9142 0.965149 11.25 1.30094 11.25 1.71515V5.46515H15C15.4142 5.46515 15.75 5.80094 15.75 6.21515C15.75 6.62936 15.4142 6.96515 15 6.96515H10.5C10.0858 6.96515 9.75 6.62936 9.75 6.21515V1.71515C9.75 1.30094 10.0858 0.965149 10.5 0.965149Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.25 9.96515C5.25 9.55094 5.58579 9.21515 6 9.21515H12C12.4142 9.21515 12.75 9.55094 12.75 9.96515C12.75 10.3794 12.4142 10.7151 12 10.7151H6C5.58579 10.7151 5.25 10.3794 5.25 9.96515Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.25 12.9651C5.25 12.5509 5.58579 12.2151 6 12.2151H12C12.4142 12.2151 12.75 12.5509 12.75 12.9651C12.75 13.3794 12.4142 13.7151 12 13.7151H6C5.58579 13.7151 5.25 13.3794 5.25 12.9651Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.25 6.96515C5.25 6.55094 5.58579 6.21515 6 6.21515H7.5C7.91421 6.21515 8.25 6.55094 8.25 6.96515C8.25 7.37936 7.91421 7.71515 7.5 7.71515H6C5.58579 7.71515 5.25 7.37936 5.25 6.96515Z'
      fill='currentColor'
    />
  </svg>
);
